import React from 'react';
import { Helmet } from 'react-helmet';
import config from 'sharedConfig';

export default function CategoryHeadTags({ query }) {
  const title = 'Saucey: Alcohol Delivery in 30 minutes';
  const description =
    'Alcohol delivery in 30 minutes. Shop 10,000+ products - Great prices! Order craft beer, wine and spirits online or download the mobile app for iOS or Android.';
  const url = `${config.site.url}/search/${query}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
